import { SELECT_PRODUCTS_BASED_ON_ALL, SELECT_PRODUCTS_BASED_ON_TAGS } from "../../constants/selectProductsBasedOn.js";
import { OPEN_MODAL_UPSELL } from "../constants/modalTypes.js";
import { nextStep } from "../store/features/action.js";
import { closeModal, openModal } from "../store/features/modal.js";

const emptyPlan = {
    id: 0,
    name: "",
    productsLimit: 0,
    collectionsLimit: 0,
    monthlyPrice: 0,
    yearlyPricePerMo: 0,
    crossedPrice: 0,
    createdAt: new Date(),
    updatedAt: new Date(),
};

const checkProductLimits = (shopData, data, allSelectedProducts, productsCount, dispatch) => {
    const currentPlan = shopData.subscriptionPlan ?? emptyPlan;

    const isBasedOnAll = data?.selectProductsBasedOn === SELECT_PRODUCTS_BASED_ON_ALL;
    const isBasedOnTags = data?.selectProductsBasedOn === SELECT_PRODUCTS_BASED_ON_TAGS;

    let allProductsCount = 0;
    let collections = [];

    const items = allSelectedProducts.length > 0 ? allSelectedProducts : data?.selectedSpecificItems ?? [];

    if (isBasedOnAll) {
        allProductsCount = shopData?.productsCount ?? 0;
    } else if (isBasedOnTags) {
        allProductsCount = productsCount;
    } else {
        const products = items.filter(({ type }) => type !== "collection");
        collections = items.filter(({ type }) => type === "collection");
        allProductsCount = collections.reduce((sum, collection) => sum + collection.productsCount, 0) + products.length;
    }

    if (allProductsCount > currentPlan.productsLimit || collections.length > currentPlan.collectionsLimit) {
        dispatch(closeModal)
        dispatch(openModal({
            modalType: OPEN_MODAL_UPSELL,
            modalData: {
                limitProductCount: allProductsCount,
                limitCollectionCount: collections.length,
                isNewContect: true,
            },
        }));
    } else {
        dispatch(nextStep());
    }
};

export default checkProductLimits;
